import { of } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { loadFlightControlActionTypes, loadingFlightControl, loadedFlightControl, loadControlTowerExperienceActionTypes, loadingControlTowerExperience, loadedControlTowerExperience, } from '../components/FlightDetails/FlightDetails.ducks';
import { loadingOverview, loadedOverview, loadOverviewActionTypes } from '../ducks/FlightOverview.ducks';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { getTenantFromManagementGroup } from '@ane/exp-data/lib/utils/ManagementGroup';
import FlightResource from '../resources/Flight.resource';
import { parseFlightOverviewDto, createExpIdScorecardMapping } from '../../../utils/FlightUtils';
import { getCompletedAsyncWrapperObj } from '@ane/core/lib/models/IAsyncWrapper';
import { loadScorecardActionTypes } from '../components/FlightExperiments/FlightExperimentList.ducks';
import ExperimentResources from '@ane/exp-data/lib/resources/ExperimentResources';
import MdsDataplaneResource from '@ane/exp-data/lib/resources/MdsDataplaneResource';
import { getExperimentationGroupIdFromPath } from '@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils';
import MasterDataConstants from '@ane/exp-data/lib/constants/FeatureDataConstants';
import { loadingScorecards, loadedScorecards } from '../components/FlightExperiments/FlightExperimentList.ducks';
import { loadingFlightVariables, loadedFlightVariables, loadFlightVariablesActionTypes, } from '../components/FlightVariables/FlightVariables.ducks';
const loadFlightOverviewArgs = {
    filterOnType: loadOverviewActionTypes.LOAD,
    loadResource: (payload, state) => {
        return FlightResource.loadFlightOverview(payload.flightId, payload.workspaceId, payload.managementGroup);
    },
    loadingAction: (payload) => loadingOverview(payload),
    loadedAction: (successData, payload, error, errorContext) => {
        // Skip parse on 301
        const result = getCompletedAsyncWrapperObj((errorContext === null || errorContext === void 0 ? void 0 : errorContext.statusCode) === 301 ? successData : parseFlightOverviewDto(successData), error || '', errorContext);
        return of(loadedOverview(payload, result));
    },
};
export const loadFlightOverviewEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadFlightOverviewArgs);
const loadScorecardDataArgs = {
    filterOnType: loadScorecardActionTypes.LOAD,
    loadResource: (payload, state) => {
        return ExperimentResources.scorecardData(payload.ids);
    },
    loadingAction: loadingScorecards,
    loadedAction: (successData, payload, error) => of(loadedScorecards(payload.flightId, getCompletedAsyncWrapperObj(createExpIdScorecardMapping(payload.ids, successData), error || ''))),
};
export const loadScorecardDataEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadScorecardDataArgs);
const loadTreatmentVariablesArgs = {
    filterOnType: loadFlightVariablesActionTypes.LOAD,
    loadResource: (payload, state) => {
        const { flightId, workspaceId, managementGroup } = payload;
        return FlightResource.loadFlightTreatmentVariablesV2(flightId, workspaceId, managementGroup, getTenantFromManagementGroup(managementGroup));
    },
    loadingAction: loadingFlightVariables,
    loadedAction: (successData, payload, error) => {
        var _a;
        const result = getCompletedAsyncWrapperObj((_a = successData === null || successData === void 0 ? void 0 : successData.TreatmentVariables) !== null && _a !== void 0 ? _a : [], error || '');
        return of(loadedFlightVariables(payload, result));
    },
};
export const loadTreatmentVariablesEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadTreatmentVariablesArgs);
const loadFlightControlArgs = {
    filterOnType: loadFlightControlActionTypes.LOAD,
    loadResource: (payload, state) => {
        const { workspaceId, managementGroup } = payload;
        const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
        return MdsDataplaneResource.getConfigWithTypeV2({
            workspaceId: workspaceId,
            experimentationGroup: experimentationGroup,
            section: MasterDataConstants.flightControlSection,
        });
    },
    loadingAction: loadingFlightControl,
    loadedAction: (successData, payload, error) => of(loadedFlightControl(payload.flightId, getCompletedAsyncWrapperObj(successData, error || ''))),
};
export const loadFlightControlEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadFlightControlArgs);
const loadControlTowerExperienceArgs = {
    filterOnType: loadControlTowerExperienceActionTypes.LOAD,
    loadResource: (payload, state) => {
        const { workspaceId, managementGroup } = payload;
        const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
        return MdsDataplaneResource.getConfigWithTypeV2({
            workspaceId: workspaceId,
            experimentationGroup: experimentationGroup,
            section: MasterDataConstants.controlTowerExperienceSection,
        });
    },
    loadingAction: loadingControlTowerExperience,
    loadedAction: (successData, payload, error) => of(loadedControlTowerExperience(payload, getCompletedAsyncWrapperObj(successData, error || ''))),
};
export const loadControlTowerExperienceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadControlTowerExperienceArgs);
export default combineEpics(loadFlightOverviewEpic, loadScorecardDataEpic, loadTreatmentVariablesEpic, loadFlightControlEpic, loadControlTowerExperienceEpic);

//# sourceMappingURL=FlightDetailsEpic.js.map
